<template>
    <div>
        <div style="min-height:32px;">

            <!-- Time -->
            <small class="text-muted pb-2" v-if="!learner">
                <i class="fas fa-clock mr-1"></i>{{ timeslot.time }}
            </small>

            <!-- Summary -->
            <h6 class="text-sm" v-if="timeslot.instructor_summary">
                {{ timeslot.instructor_summary }}
            </h6>
        </div>

        <feedback class="pb-4"
            v-for="(feedback, index) in filteredFeedbacks" :key="index"
            :feedback="feedback" :lang="lang"
            :edit="edit" :sharing="sharing" :showAuthor="showAuthor"
            :learner="learner"
            :registration="registration"
            :simulation="simulation"
            :session="session"
            @update="$emit('update', feedback)"
            @remove="$emit('remove', feedback)"
            @share="$emit('share', feedback)"
            @createNote="$emit('createNote', timeslot.id)"
            @createPicture="$emit('createPicture', timeslot.id)"
            @createIssue="$emit('createIssue', timeslot)"
        >
        </feedback>

    </div>
</template>

<script>
    import Feedback from './Feedback'

    export default {

        components: {
            Feedback
        },

        props: {
            
            registration: {
                type: Object,
                required: true
            },
            
            simulation: {
                type: Object,
                required: true
            },
            
            session: {
                type: Object,
                default: null
            },

            timeslot: {
                type: Object,
                required: true
            },

            lang: {
                type: String,
                required: true
            },

            edit: {
                type: Boolean,
                required: false
            },

            sharing: {
                type: Boolean,
                default: false
            },            

            showAuthor: {
                type: Boolean,
                default: false
            },
            
            selectedCompetencies: {
                type: Array,
                required: true
            },
            
            showPositions: {
                type: Boolean,
                default: true
            },

            showNotes: {
                type: Boolean,
                default: true
            },

            showPictures: {
                type: Boolean,
                default: true
            },

            learner: {
                type: Object,
                default: null
            },
        },

        computed: {

            filteredFeedbacks() {
                return this.timeslot.feedbacks.filter(item => {
                    return this.itemVisible(item)
                })
            }
        },

        methods: {
            
            itemVisible(item) {
                if (this.selectedCompetencies.length == 0) {
                    return this.itemTypeVisible(item)
                }
                const itemCompetencies = item.competencies.map(competency => competency.id)
                const intersect = this.selectedCompetencies.filter(x => itemCompetencies.includes(x))
                return intersect.length > 0
                    ? this.itemTypeVisible(item)
                    : false
            },
            
            itemTypeVisible(item) {
                return (item.type == 'position' && this.showPositions)
                    || (item.type == 'note' && this.showNotes)
                    || (item.type == 'picture' && this.showPictures)
            },
        }
    }
</script>
